import { z } from 'zod';

const copyKeys = [
  'sizeNote',
  'entry',
  'close',
  'title',
  'quick',
  'custom',
  'print',
  'printAction',
  'printBlocked',
  'width',
  'height',
  'unit',
  'input',
  'output',
  'actual',
  'printSize',
  'factor',
  'upload',
  'loading',
  'invalid',
  'targetMode',
  'factorMode',
  'factorInvalid',
  'factorAdjusted',
  'transparentImageRestrictionTooltip',
  'sizeOptionUnavailableTooltip',
  'limit',
  'locked',
  'estimate',
  'fit',
  'orientation',
  'preset',
  'posters',
  'photos',
  'paper',
  'resultLoading',
  'resultError',
] as const;
export type UpscalerSizeCopy = Record<(typeof copyKeys)[number], string>;
export const upscalerSizeCopySchema = z
  .object(
    Object.fromEntries(
      copyKeys.map((key) => [key, z.string().trim().min(1)])
    ) as Record<keyof UpscalerSizeCopy, z.ZodString>
  )
  .strict();
